import type { ReactNode } from 'react';

import Img from 'components/Img';
import type { ColorString } from 'types';
import { cn } from 'utils/classNames';

interface Props {
	bottomRightImageClassName?: string;
	bottomRightImageSrc?: string;
	children: ReactNode;
	className?: string;
	color: ColorString;
	contentClassName?: string;
	topLeftImageClassName?: string;
	topLeftImageSrc?: string;
}

export default function ThemedBlockContainer({
	bottomRightImageClassName,
	bottomRightImageSrc,
	children,
	className,
	color,
	contentClassName,
	topLeftImageClassName,
	topLeftImageSrc,
}: Props) {
	return (
		<div
			style={{ backgroundColor: color }}
			className={cn('relative', className)}
		>
			{topLeftImageSrc && (
				<Img
					src={topLeftImageSrc}
					alt=""
					width={810}
					height={405}
					jpgOptimized={false}
					className={cn(
						'pointer-events-none absolute top-0 left-0 max-h-full w-auto',
						topLeftImageClassName,
					)}
				/>
			)}

			<div className={cn('relative z-1', contentClassName)}>{children}</div>

			{bottomRightImageSrc && (
				<Img
					src={bottomRightImageSrc}
					alt=""
					width={810}
					height={405}
					jpgOptimized={false}
					className={cn(
						'pointer-events-none absolute right-0 bottom-0 max-h-full w-auto',
						bottomRightImageClassName,
					)}
				/>
			)}
		</div>
	);
}
ThemedBlockContainer.displayName = 'ThemedBlockContainer';
